// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"213":"b61b1f02","667":"0d0aaf89"}[chunkId] + ".chunk.js";
};